'use client';

import { memo, type ReactNode } from 'react';
import { motion, type MotionProps } from 'framer-motion';

type QuickSearchListAnimationProps = MotionProps & {
  /**
   * required children to be animated
   */
  children: ReactNode;
};

const TRANSITION_CONFIG = {
  layout: {
    duration: 0.15,
    ease: [0.25, 0.1, 0.25, 1.0],
  },
} as const;

export const QuickSearchListAnimation = memo(function QuickSearchListAnimation({
  children,
  ...otherProps
}: QuickSearchListAnimationProps) {
  return (
    <motion.div {...otherProps} layout={true} transition={TRANSITION_CONFIG}>
      {children}
    </motion.div>
  );
});

QuickSearchListAnimation.displayName = 'QuickSearchListAnimation';
